import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SystemPicker } from './SystemPicker';

export const SystemPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'SystemPicker',
        // @ts-ignore
        component: SystemPicker,
    }),
);
